import Divider from './Divider';
import './Divider.scss';

export default Divider;